/* sab-contest.js · Halloween Coloring Contest 2026 (template page.halloween-contest). Vanilla JS, no library.
   Loaded deferred by sections/sab-x-contest-rules.liquid. Ported from the prototype contest-halloween/v1.0/assets/js/sab-contest.js
   (the prototype-only ?preview=winners block is not ported: in the theme the winners show with the section setting).
   - A link to #official-rules or #rules on this page (FAQ, «How to enter», or the same path with the anchor, e.g.
     /pages/halloween-contest#official-rules) opens the rules <details> and brings it on screen.
   - Arriving with #official-rules or #rules in the address (email, ManyChat) does the same.
   Without JS the page still works: the <details> opens on tap and the anchors scroll to the section. */
(() => {
  'use strict';
  const getRules = () => document.getElementById('official-rules');

  const openRules = (focus) => {
    const rules = getRules();
    if (!rules) return false;
    rules.open = true;
    if (focus) rules.querySelector('summary')?.focus({ preventScroll: true });
    /* 18/10 QA: scroll the whole box, so the «Official Rules» title is not left under the sticky header */
    (rules.closest('.sab-contest-rules__box') || rules).scrollIntoView({ block: 'start' });
    return true;
  };
  const fromHash = () => {
    if (location.hash === '#official-rules' || location.hash === '#rules') openRules(true);
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const a = event.target.closest('a[href$="#official-rules"], a[href$="#rules"]');
    if (!a || a.target === '_blank' || a.origin !== location.origin || a.pathname !== location.pathname) return;
    if (!getRules()) return;
    event.preventDefault();
    history.replaceState(null, '', '#official-rules');
    openRules(true);
  });
  window.addEventListener('hashchange', fromHash);
  fromHash();
})();
